const e = "react-international-phone-", n = (...s) => s.filter((t) => !!t).join(" ").trim(), r = (...s) => n(...s).split(" ").map((t) => `${e}${t}`).join(" "), i = ({ addPrefix: s, rawClassNames: t }) => n(r(...s), ...t);
export {
  i as buildClassNames,
  r as classNamesWithPrefix,
  e as classPrefix,
  n as joinClasses
};
